import React from 'react';
import styles from './dropdown.module.css';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Spinner() {
  return (
    <div className={styles.progressIndicator}>
      <div className={styles.progressIndicatorIcon}>
        <CircularProgress data-testid="loader" />
      </div>
    </div>
  );
}
